<template>
  <div>
    <header-component
      :meta="{
        serviceRequestNumber: serviceRequest.serviceRequestNumber,
        averagePoints: serviceRequest.points
      }"
    />
    <div v-if="serviceRequestLogs.length != 0">
      <el-timeline class="mt--6 p-25">
        <el-timeline-item
          v-for="(item, index) in serviceRequestLogs"
          :key="index"
          :timestamp="item.date"
          placement="top"
        >
          <el-card>
            <div class="justify-between">
              <el-tag :type="item.meta.color" size="small" effect="dark">{{
                item.title
              }}</el-tag>
              <div
                v-if="
                  latestLog &&
                    item.serviceRequestLogId === latestLog.serviceRequestLogId
                "
                class="justify-between"
              >
                <div v-if="showResumeFrom">
                  <el-date-picker
                    v-model="calculateFrom"
                    type="datetime"
                    placeholder="Resume From"
                    @change="askConfirmation()"
                  />
                </div>
                <span v-else>
                  {{ time }}
                </span>
                <el-button
                  size="mini"
                  v-if="!showResumeFrom"
                  @click="stopTimer(item)"
                  class="ml-2"
                  >Change Timer</el-button
                >
              </div>
              <div v-if="item.points !== null">
                <el-tag size="mini">
                  <i class="el-icon-time">
                    Time Taken: {{ item.minutes | timeConverter }}</i
                  >
                </el-tag>
                <el-tag class="ml-2" size="mini">
                  Points :{{ item.points }}</el-tag
                >
              </div>
            </div>
            <p v-if="item.description">{{ item.description }}</p>
            <p v-if="item.identifier">
              <a style="cursor:pointer; color:blue;" @click="showDetails(item)">
                Click for details
              </a>
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

    <div v-else class="empty-container">
      No timeline added for this service request.
    </div>
    <el-dialog
      title="Confirmation"
      :visible.sync="showConfirmationBox"
      width="30%"
      ><span
        >Are you sure do you want to stop the timer and resume it from selected
        date?</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmationBox = false">Cancel</el-button>
        <el-button type="primary" @click="updateLog()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
import {
  Tabs,
  TabPane,
  Timeline,
  TimelineItem,
  Card,
  Tag,
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button,
  Autocomplete,
  DatePicker,
  Dialog
} from "element-ui";
import { mapActions, mapState } from "vuex";
import HeaderComponent from "../Components/HeaderComponent.vue";
export default {
  data() {
    return {
      time: null,
      latestLog: null,
      showDatepicker: false,
      calculateFrom: null,
      showConfirmationBox: false,
      showResumeFrom: false,
      selectedLog: {}
    };
  },
  components: {
    "header-component": HeaderComponent,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dropdown.name]: Dropdown,
    [Button.name]: Button,
    [Autocomplete.name]: Autocomplete,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog
  },
  computed: {
    ...mapState("serviceRequest", ["serviceRequest", "serviceRequestLogs"])
  },

  async mounted() {
    await this.fetchServiceRequest(this.$route.params.id);
    await this.getServiceRequestLogs(this.$route.params.id);
    this.getCountdownTiming();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  filters: {
    timeConverter(num) {
      if (num >= 1440) {
        const days = num / 1440;
        return days.toString().split(".")[0] + " day/s";
      } else if (num >= 60) {
        const hours = Math.floor(num / 60);
        const minutes = num % 60;
        return hours + " Hrs " + minutes + " Min/s.";
      } else {
        return num + " Min/s";
      }
    }
  },

  methods: {
    ...mapActions("serviceRequest", [
      "getServiceRequestLogs",
      "fetchServiceRequest",
      "updateServiceRequestLog"
    ]),
    showDetails(item) {
      let activeStep = 0;
      switch (item.meta.type) {
        case "quotation":
          window.open(`/quotation/${item.identifier}`, "_blank");
          break;
        case "chalan":
          window.open(`/chalan/${item.identifier}`, "_blank");
          break;
        case "labor":
          activeStep = 3;
          break;
        case "transaction":
          activeStep = 4;
          break;
        case "sale":
          window.open(`/pos/${item.identifier}`, "_blank");
          break;
        default:
          break;
      }
      const route = this.$router.resolve({
        name: "Service Request Flow",
        query: { activeStep: activeStep }
      });
      window.open(route.href, "_blank");
    },

    getCountdownTiming() {
      if (this.serviceRequest.status.code != "completed") {
        const filteredLogs = this.serviceRequestLogs.filter(
          i =>
            i.calculateFrom != null &&
            (i.title === "Vendor Invoice Raised" ||
              i.title === "Quotation Raised" ||
              i.title === "Site Visited" ||
              i.title === "Called To Customer" ||
              i.title === "Vendor Assigned" ||
              i.title === "Service Request Created")
        );
        this.latestLog = filteredLogs[0];
        if (this.latestLog) {
          const x = setInterval(() => {
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance =
              now - new Date(this.latestLog.calculateFrom).getTime();

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor(
              (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            var minutes = Math.floor(
              (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (distance < 0) {
              clearInterval(x);
              this.time = "done";
            }
            //setting value to time variable
            if (seconds > 0) {
              this.time =
              days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
            } else{
              this.time = 'Calculate Time From : ' + format(new Date(this.latestLog.calculateFrom), 'DD-MM-YYYY hh:mm aa  ') ;
            }
          }, 500);
        }
      }
    },
    stopTimer(log) {
      this.showResumeFrom = true;
      this.selectedLog = log;
    },

    askConfirmation() {
      this.showConfirmationBox = true;
    },
    updateLog() {
      this.updateServiceRequestLog({logId: this.selectedLog.serviceRequestLogId, calculateFrom:this.calculateFrom }).then(async (res) => {
        await this.getServiceRequestLogs(this.$route.params.id);
        this.showConfirmationBox = false;
        this.showResumeFrom = false;
        this.getCountdownTiming();

      });
    }
  }
};
</script>

<style>
.empty-container {
  padding-left: 360px;
  padding-bottom: 280px;
}

.justify-between {
  justify-content: space-between;
  display: flex;
}

.p-25 {
  padding: 25px;
}
</style>
